export default "__VITE_ASSET__BwhLnMEX__"